import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from 'components/StyledButton/StyledButton';

import CustomDialog from '../../components/CustomDialog/CustomDialog';
import { StyledDialogContent } from '../../components/EntitySelectDialog/styled';
import { downloadFile } from '../../utils/download';

const PdfPreviewDialog = () => {
    const { t } = useTranslation();

    const [isOpen, setIsOpen] = useState(false);
    const [blob, setBlob] = useState<any>(null);
    const [url, setUrl] = useState('');
    const [filename, setFilename] = useState('');

    const onClose = useCallback(() => {
        setIsOpen(false);
    }, []);

    const download = useCallback(() => {
        downloadFile(blob, filename, true);
    }, [blob, filename]);

    // @ts-ignore
    window.openPdfPreview = useCallback((content: Blob, name: string) => {
        // @ts-ignore
        const newUrl = URL.createObjectURL(content.slice(0, content.size, 'application/pdf'));
        setBlob(content);
        setUrl(newUrl);
        setFilename(name);
        setIsOpen(true);
    }, []);

    return (
        <>
            <CustomDialog onClose={() => onClose()} open={isOpen} maxWidth={'lg'} fullWidth >
                <DialogTitle>
                    {filename}
                </DialogTitle>

                <StyledDialogContent dividers style={{ height: '2000px', padding: 0, overflow: 'hidden' }}>
                    <embed src={url} width='100%' height='100%' />
                </StyledDialogContent>

                <DialogActions>
                    <Button onClick={() => download()} color='primary'>
                        {t('dialogs.pdf_preview.download')}
                    </Button>

                    <Button onClick={() => onClose()} color='primary'>
                        {t('dialogs.generic.close')}
                    </Button>
                </DialogActions>
            </CustomDialog>
        </>
    );
};

export default PdfPreviewDialog;
